import React, { useState } from 'react';
import { Dashboard } from '@components/common';
import { Button, Dropdown } from '@fourthwall/components';
import { CalendarIcon } from '@fourthwall/icons';
import { StatGroup } from '@fourthwall/module-analytics';
import { useOverviewContext } from '../../hooks/useOverviewContext';
import { AnalyticsSkeleton } from './AnalyticsSkeleton';
import { MembersChangeChart } from './components/MembersChangeChart/MembersChangeChart';
import { MembersTotalChart } from './components/MembersTotalChart/MembersTotalChart';
import { ProfitChart } from './components/ProfitChart/ProfitChart';
import { TABS } from './consts';
import * as S from './styled';
export const Analytics = () => {
    const overview = useOverviewContext();
    const [range, setRange] = useState(30);
    const [isOpen, setIsOpen] = useState(false);
    if (overview.isLoading || overview.hasAnyTier === null)
        return React.createElement(AnalyticsSkeleton, null);
    if (overview.hasAnyTier === false)
        return null;
    if (overview.onboarding.active)
        return null;
    const dropdownContent = (React.createElement(S.DropdownContent, null, TABS.map((tab) => (React.createElement(Dropdown.Item, { key: tab.value, label: tab.label, active: tab.value === range, onClick: () => {
            setIsOpen(false);
            setRange(Number(tab.value));
        }, cursor: "pointer" })))));
    return (React.createElement("div", null,
        React.createElement("div", { style: { marginBottom: 24, justifySelf: 'start' } },
            React.createElement(Dropdown, { content: dropdownContent, position: "bottom-start", maxWidth: 280, isOpen: isOpen, onClose: () => setIsOpen(false) },
                React.createElement(Button, { size: "xsmall", appearance: "secondary", label: TABS.find((tab) => tab.value === range)?.label || '', leftIcon: React.createElement(CalendarIcon, null), onClick: () => setIsOpen(!isOpen) }))),
        React.createElement(Dashboard.Section.ScrollableContent, { hideScrollbar: true, fullWidth: true },
            React.createElement(StatGroup, null,
                React.createElement(S.Stat, null,
                    React.createElement(MembersTotalChart, { range: range })),
                React.createElement(S.Stat, null,
                    React.createElement(MembersChangeChart, { range: range })),
                React.createElement(S.Stat, null,
                    React.createElement(ProfitChart, { label: TABS.find((tab) => tab.value === range)?.profitChartLabel || 'Profit', range: range }))))));
};
